/**
 * Save component for Tabbed Docs block
 * Returns null as rendering is done server-side via PHP
 */
export default function Save() {
	return null;
}
